import { SELECT_CHORD, SELECT_ROOT, REQUEST_CHORD_DATA, CHORD_DATA_LOADED } from './Actions'
import { combineReducers } from 'redux'

function selectedChord(state = 0, action) {
    switch (action.type) {
        case SELECT_CHORD:
            return action.chordId
        default:
            return state
    }
}

function selectedRoot(state = 0, action) {
    switch (action.type) {
        case SELECT_ROOT:
            return action.rootId
        default:
            return state
    }
}

const initialDataState = {
    isLoading: true
}

function chordData(state = initialDataState, action) {
    switch(action.type) {
        case REQUEST_CHORD_DATA:
            return {
                isLoading: true,
            }
        case CHORD_DATA_LOADED:
            return {
                isLoading: false,
                data: action.chordData
            }
        default:
            return state
    }
}

const rootReducer = combineReducers({
    selectedRoot,
    selectedChord,
    chordData
})

export default rootReducer




// WEBPACK FOOTER //
// ./src/Reducers.js